module.exports = __webpack_public_path__ + "img/mc2.0fb49c18.jpg";